import React, { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Paper,
  TextField,
  Typography,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CourierLayout from '../CourierLayout';

const CourierReferrals = () => {
  const [message, setMessage] = useState('');

  const inviteLink = 'https://www.hagglefreight.com';

  const copyInviteLink = async () => {
    try {
      await navigator.clipboard.writeText(inviteLink);
      setMessage('Invite link copied.');
    } catch (error) {
      setMessage('Unable to copy invite link.');
    }
  };

  return (
    <CourierLayout>
      <Box sx={{ mb: 3 }}>
        <Typography
          variant="h4"
          sx={{
            fontSize: '2rem',
            fontWeight: 700,
            lineHeight: 1.25,
            color: '#0f172a',
            mb: 1,
            textAlign: 'center',
          }}
        >
          Referrals
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: '#64748b',
            textAlign: 'center',
            fontSize: '0.95rem',
            lineHeight: 1.5,
          }}
        >
          Share HaggleFreight with trusted drivers and carriers.
        </Typography>
      </Box>

      {message && (
        <Alert
          severity={message.includes('copied') ? 'success' : 'warning'}
          sx={{
            mb: 2,
            borderRadius: 2,
          }}
        >
          {message}
        </Alert>
      )}

      <Paper
        elevation={1}
        sx={{
          maxWidth: 640,
          mx: 'auto',
          p: { xs: 2.5, md: 3 },
          borderRadius: 3,
          border: '1px solid rgba(15, 23, 42, 0.08)',
          backgroundColor: '#ffffff',
        }}
      >
        <Typography
          variant="subtitle1"
          sx={{
            color: '#0f172a',
            fontWeight: 700,
            mb: 1,
          }}
        >
          Invite Link
        </Typography>

        <Typography
          variant="body2"
          sx={{
            color: '#64748b',
            fontSize: '0.95rem',
            lineHeight: 1.5,
            mb: 2,
          }}
        >
          Copy your invite link and share it directly.
        </Typography>

        <TextField
          fullWidth
          value={inviteLink}
          InputProps={{
            readOnly: true,
          }}
          sx={{
            mb: 2,
          }}
        />

        <Button
          variant="contained"
          fullWidth
          startIcon={<ContentCopyIcon />}
          onClick={copyInviteLink}
          sx={{
            minHeight: 44,
            textTransform: 'none',
            fontWeight: 700,
            borderRadius: 2,
          }}
        >
          Copy Invite Link
        </Button>
      </Paper>
    </CourierLayout>
  );
};

export default CourierReferrals;